import Flag from './Flag';

export default Flag;
